export default __webpack_public_path__ + "static/media/TradingVillage.08ffdb7d.jpg";